import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-final-design-proposal',
  templateUrl: './final-design-proposal.component.html',
  styleUrls: ['./final-design-proposal.component.css']
})
export class FinalDesignProposalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/customer/final-design-proposal/final-design-proposal.component.ts